import { Component, Vue, PropSync, Watch, Emit } from 'vue-property-decorator';

import { TableLineCloneItem } from '@/models/tables/TableLineCloneItem';

@Component
export default class ProcessSelectMenu extends Vue {
    @PropSync('show', { type: Boolean }) public syncedShow!: boolean;
    @PropSync('items', { type: Array }) public syncedItems!: TableLineCloneItem[];
    public isAll: boolean = false;

    // tslint:disable-next-line: no-empty
    public mounted() {
    }

    @Emit()
    public Clone(): boolean {
        return true;
    }

    public selectAllProcesses() {
        this.syncedItems.forEach((item) => {
            item.selected = this.isAll;
        });
    }

    public onCloneClicked() {
        this.Clone();
        this.syncedShow = false;
    }
}
